exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-orange {\n    background-color: #ef871d;\n    color: #fff;\n}\n.VueTables__table th:last-child{\n    max-width: 130px;\n    width: 130px;\n}\n", ""]);

// exports
